module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Copyright"
    }
  }, [_c('p', {
    staticClass: "fmh1",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Contents#rscopy"
    }
  }, [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2020 by James Carlos Blake")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Cover design by Cindy Hernandez")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover photographs: sun with palm trees © Delphotos/Alamy Stock Photo; hawk © Prisma by Dukas Presseagentur GmbH/Alamy Stock Photo")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or permissions@groveatlantic.com.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('i', [_vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First Grove Atlantic eBook edition: July 2020")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIRST EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN 978-0-8021-5688-4")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978-0-8021-5696-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication data is available for this title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("The Mysterious Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("an imprint of Grove Atlantic")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("154 West 14th Street")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("groveatlantic.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c5f386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780802156969_Copyright.vue
// module id = 69
// module chunks = 0